import React from 'react';
import { BrowserRouter as Router } from "react-router";
import ReactDOM from 'react-dom/client';
import './styles/index.scss';
import App from './App.js';
import reportWebVitals from './reportWebVitals';
import ReactGA from "react-ga4";

// Measurement ID: G-PSGMHWPS5Q
ReactGA.initialize("G-HY3C4DZVZW");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
